import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Layout from '@/views/layouts/desktop/Root.vue';
import Contents from './Contents.vue';
import Top from './Top.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    "left-width": 220,
    "left-full": true
  }, {
    "left-side": _withCtx(() => [
      _createVNode(Contents)
    ]),
    "top-bar": _withCtx(() => [
      _createVNode(Top)
    ]),
    _: 1
  }))
}
}

})